import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '编号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '品牌'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'serial',
    fieldName: '序列号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'unit',
    fieldName: '单位'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTypeName',
    fieldName: '维修类型'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'typeName',
    fieldName: '业务类型'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessClass',
    fieldName: '业务分类'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'urgentName',
    fieldName: '紧急程度'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesManName',
    fieldName: '业务员'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTimes',
    fieldName: '返修次数'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fault',
    fieldName: '故障描述'
  }
]
